import { Button, Modal } from '@warp-ds/react';

type Props = {
    toggleModal: () => void;
    isOpen: boolean;
};

const SafetyInfoModal = (props: Props) => {
    const { toggleModal, isOpen } = props;

    return (
        <Modal
            right
            open={isOpen}
            onDismiss={() => toggleModal()}
            title="Slik fungerer bestilling av feriehjem på FINN.no"
            footer={
                <Button
                    data-testid="safetyInfoModalCloseButton"
                    primary
                    onClick={() => {
                        toggleModal();
                    }}>
                    Lukk
                </Button>
            }>
            <ol start={1} className="list-decimal font-bold mx-12">
                <li className="mb-14">
                    <div className="ml-8">Send forespørsel</div>
                    <div className="font-normal ml-8">
                        Velg ønsket periode og send forespørsel til utleier. Ingen betaling blir reservert før du får svar.
                    </div>
                </li>
                <li className="mb-14">
                    <div className="ml-8">Få svar innen 48 timer</div>
                    <div className="font-normal ml-8">
                        Utleier vurderer forespørselen din. Du får svar så snart den er behandlet - alltid innen 48 timer.
                    </div>
                </li>
                <li className="mb-14">
                    <div className="ml-8">Godkjenning og betalingsinformasjon</div>
                    <div className="font-normal ml-8">Hvis forespørselen godkjennes, får du en bekreftelse med betalingsinformasjon.</div>
                </li>
                <li className="mb-14">
                    <div className="ml-8">Fullfør med betaling</div>
                    <div className="font-normal ml-8">Først når du har betalt, blir bestillingen bindende - både for deg og utleier.</div>
                </li>
            </ol>
        </Modal>
    );
};

export default SafetyInfoModal;
